import { isArray } from 'lodash';

/**
 * 檢查是否為空的方案資料
 * @param {Object|Array} planItems - 方案資料
 * @returns {boolean} - 是否為空
 */
export const isEmptyPlanItems = planItems => {
    if (!planItems) return true;
    if (isArray(planItems)) return planItems.length === 0;
    return Object.keys(planItems).length === 0;
};
